"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Video, Film, Clapperboard } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
export default function OurServices() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const services = [{
    icon: Video,
    title: "Location Scouting & Management",
    description: "We find and secure the ideal locations for your production, handling everything from permits and legal approvals to on-site coordination and transportation logistics. Our team ensures that each location fits your creative vision while minimizing disruptions, making your shoot efficient and stress-free.",
    link: "/location-scouting-set-design-and-crew-scheduling/"
  }, {
    icon: Film,
    title: "Set Design & Prop Coordination",
    description: "From conceptualizing the environment to sourcing and organizing props, furniture, and set dressing, we manage all elements of physical production. We coordinate with art departments, suppliers, and vendors to ensure that your sets are ready on time, within budget, and aligned with your director's vision.",
    link: "/location-scouting-set-design-and-crew-scheduling/"
  }, {
    icon: Clapperboard,
    title: "Crew & Production Scheduling",
    description: "We optimize shooting schedules, coordinate multiple departments, and manage equipment logistics to maximize efficiency on set. Our production planning covers daily call sheets, contingency plans, and resource allocation, so your crew can work smoothly and focus on getting the shots you need.",
    link: "/location-scouting-set-design-and-crew-scheduling/"
  }];
  const refs = [ref1, ref2, ref3];
  const visibilities = [isVisible1, isVisible2, isVisible3];
  return <section id="our-services" className="bg-background py-20 px-6">
      <div className="mx-auto max-w-7xl">
        <div className="mb-16 text-center">
          <h2 className="font-display text-4xl font-bold text-foreground md:text-5xl">
            Our Services
          </h2>
        </div>

        <div className="grid gap-8 md:grid-cols-3">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <div key={i} data-index={i} ref={refs[i]} className={`transition-all duration-200 ease-[cubic-bezier(0.4,0,0.2,1)] ${visibilities[i] ? "translate-y-0 opacity-100" : "translate-y-3 opacity-0"}`}>
                <Card className="h-full border border-border shadow-soft hover:shadow-medium transition-shadow duration-[var(--duration-medium)]">
                  <CardHeader className="items-center text-center">
                    <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-lg bg-primary/10">
                      <Icon className="h-8 w-8 text-primary-dark" strokeWidth={1.5} />
                    </div>
                    <CardTitle className="text-xl font-semibold text-foreground">
                      {service.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="space-y-4 text-center">
                    <CardDescription className="text-muted-foreground leading-relaxed">
                      {service.description}
                    </CardDescription>
                    <Link to={service.link} className="inline-block text-sm font-medium text-foreground hover:underline transition-all duration-[var(--duration-fast)]">
                      Learn More →
                    </Link>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}